<template>

        <div v-if="!paid" class="paypal-button-shell">
          <div v-if="loading" class="paypal-button-status">Cargando botón seguro de PayPal...</div>
          <div v-if="loadError" class="paypal-button-status paypal-button-status--error">No pudimos cargar PayPal. Revisa tu conexión o intenta otro método.</div>
          <div v-show="!loadError" ref="paypalButtonContainer" class="paypal-button-container"></div>
        </div>    
    
    </template>

<script>
import { loadScript } from '@paypal/paypal-js';
export default {
  name: 'VueEx',
  data() {
    return {
      paid: false,
      loading: true,
      loadError: false,
    };
  },
  props: {
    cartTotal: {
      type: Number,
      default: 0.01,
    },
  },
  mounted() {
    loadScript({ 'client-id': CLIENT_ID, currency: 'USD' }).then((paypal) => {
      const renderResult = paypal
        .Buttons({
          style: {
            layout: 'vertical',
            shape: 'rect',
            height: 54,
            color: 'black',
            tagline: false,
          },
          createOrder: this.createOrder,
          onApprove: this.onApprove,
        })
        .render(this.$refs.paypalButtonContainer)
      setTimeout(() => {
        if (!this.loadError) this.loading = false
      }, 1200)
      return Promise.resolve(renderResult).then(() => {
        this.loading = false
      })
    }).catch(() => {
      this.loading = false
      this.loadError = true
    });
  },
  methods: {
    createOrder: function(data, actions) {
      console.log('Creating order...');
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: this.cartTotal,
              currency_code: 'USD',
            },
          },
        ],

        application_context: {
        shipping_preference: 'NO_SHIPPING'
      }
      });
    },
    onApprove: function(data, actions) {
      console.log('Order approved...');
      console.log(data)
      let tran_id=data.orderID
      console.log(tran_id)
      return actions.order.capture().then(() => {
        this.paid = true;
       
        this.$emit('messageFromPaypal', tran_id)
        //emit
        console.log('Order complete');
      });
    },
  },
};
const CLIENT_ID = 'ASBsW-vGnNIzt-UnyZh3_FHirYsqa3alWmdHPpjEYp-HaCH1lFaTWvVShCOZuiRpu4kwvb-GDItEm4RM';
</script>



<style>
.paypal-button-container {
  width: 100%;
  margin: 0;
}

.paypal-button-shell {
  display: grid;
  gap: 10px;
  width: 100%;
}

.paypal-button-status {
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(226, 238, 250, 0.84);
  font-size: 0.9rem;
  font-weight: 800;
  text-align: center;
}

.paypal-button-status--error {
  background: rgba(248, 113, 113, 0.14);
  color: #ffd4d4;
}

.paypal-button-container > div,
.paypal-button-container > div > div {
  width: 100% !important;
  max-width: none !important;
}

.paypal-button-container .paypal-buttons,
.paypal-button-container iframe {
  width: 100% !important;
  max-width: none !important;
}
#confirmation {
  color: green;
  margin-top: 1em;
  font-size: 2em;
}
</style>
